var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6d0fa6b86392675316dc81811975f2399be60507"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@lit-fibre-ltd"]={id:"6d0fa6b86392675316dc81811975f2399be60507"};
      